import src from "IMAGE";
export default { src, width: 864, height: 441, blurWidth: 0, blurHeight: 0};
